var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#febe10;}.cls-4{fill:#ff75b0;}.cls-5{fill:#00d89a;}.cls-6{fill:#ffa068;}.cls-7{fill:#00a0df;}.cls-8{fill:#0072b2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600,525.6H.34V421.35l224.8-199,138,78.45a35.83,35.83,0,0,0,43-5.8L518.89,182.33,558,226.26c14.7,16.5,42,6.1,42-16Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 102.38,
    width: 122.35,
    height: 488.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.93,
    y: 99.48,
    width: 122.35,
    height: 488.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 317.76,
    y: 99.48,
    width: 122.35,
    height: 488.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 477.12,
    y: 99.48,
    width: 122.35,
    height: 488.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578.73,16.28,451.47,1.51C429.53-1,416.06,24.87,430.75,41.37l40.4,45.37L374.83,183,238,105.21a35.81,35.81,0,0,0-41.72,4.57L.34,284.21v95.14l224.8-199,138,78.45a35.83,35.83,0,0,0,43-5.8L518.89,140.33,558,184.26c14.7,16.5,42,6.1,42-16V40.16A24,24,0,0,0,578.73,16.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.49,
    y: 553.96,
    width: 599.51,
    height: 45.88
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderDashboard);
export default __webpack_public_path__ + "static/media/provider_dashboard.3c33bff8958b0e53643143a202724d20.svg";
export { ForwardRef as ReactComponent };